<template>
  <div v-if="tracks" class="recommended-tracks flex box m-t-1">
    <h1 class="list-heading">Recommended tracks</h1>
    <ul class="track-list flex">
        <li class="track flex m-a-between s-a-center">
          <div class="track-link"></div>
          <div class="header track-number">#</div>
          <div class="header track-name">Name</div>
          <div class="header track-preview">Preview</div>
          <div class="header track-artist">Artist</div>
          <div class="header track-album">Album</div>
        </li>
        <li class="track flex m-a-between s-a-center" v-for="(track, index) in previewTracks" :key="index">
          <div class="track-link flex s-a-center">
            <a class="flex" target="blank" :href="`https://open.spotify.com/track/${track.id}`">
              <img src="../../../public/images/link.svg" width="20" height="20" alt="">
            </a>
          </div>
          <div class="track-number">{{index + 1}}</div>
          <div class="track-name">{{track.name}}</div>
          <div class="track-preview" @click="showPreviewTrack(track)">
            <svg v-if="track.preview_url !== null" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#454F8C" d="M20 2.5V0L6 2v12.17A3 3 0 0 0 5 14H3a3 3 0 0 0 0 6h2a3 3 0 0 0 3-3V5.71L18 4.3v7.88a3 3 0 0 0-1-.17h-2a3 3 0 0 0 0 6h2a3 3 0 0 0 3-3V2.5z"/></svg>
          </div>
          <div class="track-artist">{{track.artists[0].name}}</div>
          <div class="track-album">{{track.album.name}}</div>
        </li>
    </ul> 
  </div>    
</template>

<script>
import {bus} from '../../main';

export default {
  name: 'recommendetTracks',
  props: ['tracks'],
  methods: {
    showPreviewTrack(track) {
      track.showPreviewTrack = !track.showPreviewTrack;
      this.$forceUpdate();
      bus.$emit('sendTrackToPlayer', track.preview_url);
    }
  },
  mounted() {
  },
  created() {
  },
  computed: {
    previewTracks(){
      if (!this.tracks) {
        return [];
      }
      return this.tracks.map((track) => {
        track.showPreviewTrack = false;
        return track;
      });
    },
  }
}
</script>

<style scoped>
  .recommended-tracks {
    width: 100%;
  }
  .list-heading {
    margin: 1rem 2rem .4rem 2rem;
  }
  .track-list {
    width: 100%;
    padding: 0 0 1rem 0;
  }
  .track {
    width: 100%;
    color: #454F8C;
    padding: .5rem 2rem;
    border-bottom: 1px solid hsla(232, 34%, 93%, 1);
  }
  .track:last-child {
    border-bottom: none;
  }
  .track > * {
    margin: 0 .5rem;
  }
  .header {
    font-weight: bold;
  }
  .track-number,
  .track-link {
    flex: 1;
  }
  .track-preview {
    flex: 2;
    cursor: pointer;
  }
  .track-name {
    flex: 7;
  }
  .track-artist {
    flex: 5;
  }
  .track-album {
    flex: 7;
  }
  .track-link a {
    border-bottom: none;
    opacity: .2;
  }
  .track-link a:hover { opacity: 1; }
  .list-heading {
  }
</style>